import urlConfig from '../configs/url-config'
import fetchUtil from '../util/fetchUtil'
import authHeaderUtil from '../util/authHeaderUtil'

export default {
  savePreviewSettings: async (data) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/sceneContent/preview-settings`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    await fetchUtil.request({ method, url, headers, data })
  }
}
